import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { IUser } from "../shared/getCurrentUser";

type Props = {
  userInfo: IUser | undefined;
};

export function UserInfoAndLicencesSection({ userInfo }: Props) {
  const { t } = useTranslation();

  if (!userInfo) {
    return <p>{t("home.error")}</p>;
  }

  if (userInfo.Bought) {
    return (
      <div>
        <ul>
          <li>
            <p>{t("userLicenses.hasLicense")}</p>
          </li>
        </ul>
      </div>
    );
  }

  return (
    <div>
      <p>{t("userLicenses.noLicense")}</p>
      <Link to="/buy">
        <p>{t("userLicenses.buyHere")}</p>
      </Link>
    </div>
  );
}
